import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore, rolesAtLeast, type Role } from "@/stores/auth";
import ForbiddenPage from "@/pages/ForbiddenPage";

interface Props {
  min: Role;
}

export default function RequireRole({ min }: Props) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!rolesAtLeast(user.role, min)) return <ForbiddenPage />;
  return <Outlet />;
}
